// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import { useGlobalState } from './globalState/GlobalStateProvider';
import Col from './form/Col';
import styled from 'styled-components';
import Card from '../_pwa/Card';
import Modal from './Modal';
import Loading from './Loading';
import { HamQuest } from '../../App';
import { QuestRoute } from './api/QuestRoutes';
import PaymentForm from './PaymentForm';
import Button from './form/Button';
import Heading from './form/Heading';
import Form from './form/Form';
import Select from './form/Select';
import Input from './form/Input';

const Wrapper = styled.div`
    width: 100svw;
    height: 100svh;

    background: #e9e9ed;

    display: flex;
    align-items: center;
    justify-content: center;
`
const StyledForm = styled(Form)`
    width: 80vw;
    max-width: 600px;
`;

const AccountUpdate = ({ ...props }) => {
    const {
        state: {active_user },
        getUser,
    } = useGlobalState();

    const user = '123456789'

    const [cardAdded, setCardAdded] = useState(false);

    const verifyZipCode = () => {
        return new Promise((resolve, reject) => {
            const zipForm = (
                <StyledForm
                    inputs={{
                        zipCode: '',
                    }}
                    onSubmit={(e) => {
                        Modal.Close();
                        const userModel = { ...(active_user.account || {}) };
                        userModel.zipPostalCode = e.zipCode;
                        return HamQuest.postPost(QuestRoute.user.signUp, userModel)
                            .then(() => getUser())
                    }}
                    submitButton='Update Zip Code'
                    localForm
                >
                    <Input
                        label='Zip Code'
                        name='zipCode'
                        type='text'
                        required
                        disabledcondition='useHome'
                    />
                </StyledForm>
            )

            Modal.Show({
                title: 'Verify Card Zip Code',
                body: zipForm,
                icon: 'creditCard'
            })
        })
    }

    const addCardToAccount = () => {
        return new Promise(async (resolve, reject) => {
            let res = false;
            while (res !== true) {
                res = await tokenizeCard(0);
                if (res !== true) {
                    await Modal.Confirmation({
                        title: 'An Error has occurred',
                        body: <div>{res}<br /><br />Would you like to try again?</div>,
                        type: 'error',
                        closeAfter: true,
                    })
                        .then(res => {
                            if (!res) throw new Error('Failed to tokenize Card')
                        })
                }
            }
            resolve(true)
        })
    }

    const tokenizeCard = (amount) => {
        return new Promise((resolve, reject) => {
            Modal.Promise({
                title: 'Building Payment Form',
                body: <Loading />,
            })
            const socket = HamQuest.webSocket(process.env.REACT_APP_WS_URL);

            socket.error = e => {
                Modal.Show({
                    title: 'Unable to Connect',
                    body: 'Unable to add a card at this time, please try again later.',
                    type: 'error',
                })
            };

            socket.ready = () => {
                Modal.Show({
                    title: 'Add a Card',
                    icon: 'creditCard',
                    body: (
                        <Col>
                            <span style={{ fontSize: '0.6em' }}>For security reasons a second form may open in a new window.</span>
                            <PaymentForm socketId={socket.id} amount={amount || 1} />
                        </Col>
                    )
                })
                    .finally(() => socket.close(1000))
            };

            socket.messaged = e => {
                socket.close();
                try {
                    if (e.success) {
                        Modal.Close();
                        resolve(true);
                    } else {
                        resolve(e.errorMessage || 'An Error has occurred whilst adding your card.');
                    }
                }
                catch (e) {
                    reject({ errorMessage: e });
                }
            };
        })
    }


    const addCard = async () => {
        const error = { title: 'Failed to resign up', errorMessage: 'You need to add a new card to your account to sign back up to a Wash Club.' }
        if (
            await addCardToAccount(user)
        ) {
            setCardAdded(true)
        }
    }

    return (
        <Wrapper>
            <Card title='Wash Club Re-Sign Up' icon='creditCard'>
                <Heading>{cardAdded ? 'Now sign back up to a wash club!' : 'After adding a new Credit Card to your account you can sign back up to a wash club!'}</Heading>
                {cardAdded ? (
                    <Form
                        inputs={{ productId: user.productId || 52 }}
                        onSubmit={e => {
                            // resign back up and charge card. If failed on payment set cardAdded back to false.
                        }}
                        localForm
                        text='Sign Up'
                    >
                        {({ values }) => (
                            <>
                                <Select
                                    label='Wash Club'
                                    name='productId'
                                    required
                                />
                                <Input
                                    label='Price'
                                    // value={washClubs.find(e => e.productId === parseInt(values.productId))?.monthlyPrice}
                                    type='price'
                                    readOnly
                                    standalone
                                />
                            </>
                        )}
                    </Form>
                ) : <Button onClick={addCard}>Add a new Card to your Account</Button>}
            </Card>
        </Wrapper>
    )
}

export default AccountUpdate;